var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type==3 || _vm.type==2)?_c('page-one'):(_vm.type==1 || _vm.type==5)?_c('page-two'):(_vm.type==4 || _vm.type==6)?_c('page-three'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }